import { Badge, Layout, Menu, notification, Space } from "antd";
import style from "./index.module.scss";
import classNames from "classnames/bind";
import {
  BarChartOutlined,
  CalendarOutlined,
  ShopOutlined,
  UserOutlined,
  GoldOutlined,
  InboxOutlined,
  CalculatorOutlined,
  RiseOutlined,
  HomeOutlined,
  NotificationOutlined
} from "@ant-design/icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getUser } from "utils/index";
import { useEffect, useMemo, useState } from "react";
import { roles } from "constants/index";
import { useTranslation } from "react-i18next";
import notificationApi from "api/notification";
import { rolesBox, rolesFetchCountNoti, rolesIngredientSushi, rolesNavListEmployee, rolesNavListShop, rolesNavNoti, rolesNotNavTimesheet, rolesRevenue } from "./roles";

const cx = classNames.bind(style);

const { Sider } = Layout
export default function SideBar({ collapsed, setCollapsed }) {
  const [api, contextHolder] = notification.useNotification();
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const user = getUser();

  const [countNotification, setCountNotification] = useState(0)

  const { t } = useTranslation()

  const getItem = (label, key, icon, children, type, isShow = true) => {
    return {
      key,
      icon,
      children,
      label,
      type,
      isShow
    };
  };

  const openNotificationWithIcon = (type, message, description) => {
    api[type]({ message, description, duration: 30 });
  };

  const items = useMemo(() => {
    return [
      getItem(
        <div>
          {t('notification')}
        </div>,
        "/admin/notification",
        <Badge dot={countNotification > 0}><NotificationOutlined /></Badge>,
        null,
        null,
        rolesNavNoti.includes(+user.role)
      ),
      getItem(
        <div>
          {t('timesheet')}
        </div>,
        "/admin/timesheet",
        <CalendarOutlined />,
        null,
        null,
        !rolesNotNavTimesheet.includes(+user.role)
      ),
      getItem(
        <div>
          {t('listEmployee')}
        </div>,
        "/admin/users",
        <UserOutlined />,
        null,
        null,
        rolesNavListEmployee.includes(+user.role)
      ),
      getItem(
        <div>
          {t('listShop')}
        </div>,
        "/admin/shops",
        <ShopOutlined />,
        null,
        null,
        rolesNavListShop.includes(+user.role)
      ),
      getItem(
        <div>
          {t('ingredientSushi')}
        </div>,
        "/admin/ingredients",
        <GoldOutlined />,
        null,
        null,
        rolesIngredientSushi.includes(+user.role)
      ),
      getItem(
        <div>
          {t('boxSushi')}
        </div>,
        "/admin/boxes",
        <InboxOutlined />,
        null,
        null,
        rolesBox.includes(+user.role)
      ),
      getItem(
        <div>
          {t('computeSushi')}
        </div>,
        "/admin/calculator-sushi",
        <CalculatorOutlined />,
      ),
      getItem(
        <div>
          {t('revenue')}
        </div>,
        "/admin/revenues",
        <BarChartOutlined />,
        null,
        null,
        rolesRevenue.includes(+user.role)
      ),
      getItem(
        <div>
          {t('inventory')}
        </div>,
        "/admin/inventory",
        <HomeOutlined />,
      ),
      getItem(
        <div>
          {t('growth')}
        </div>,
        "/admin/netto",
        <RiseOutlined />,
        null,
        null,
        rolesRevenue.includes(+user.role)
      ),
    ];
  }, [t, countNotification, user.role]);

  const onChangeMenu = (val) => {
    navigate(val.key)
  }

  const fetchCountNotification = async () => {
    try {
      const res = await notificationApi.getUnread()
      setCountNotification(res.total)
      if (res.total > 0) {
        openNotificationWithIcon("info", t('notification'), <Space direction="vertical">
          <span>{`${t('youHave')} ${res.total} ${t('unreadNotification')}`}</span>
          <Link to="/admin/notification">{t('goToNotification')}</Link>
        </Space>)
      }
    } catch (error) {
      console.log("🚀 ~ error:", error)
    }
  }

  useEffect(() => {
    if (rolesFetchCountNoti.includes(+getUser()?.role)) {
      fetchCountNotification()
    }
  }, [])

  return (
    <Sider onCollapse={(val) => setCollapsed(val)} collapsible collapsed={collapsed} className={cx('sider')}>
      {contextHolder}
      <div className={cx("logo")}></div>
      <Menu
        mode="inline"
        selectedKeys={[pathname]}
        onClick={onChangeMenu}
        style={{ width: "100%" }}
        items={items.filter(item => item.isShow)}
      />
    </Sider>
  );
}
